import React from 'react';
import PropTypes from 'prop-types';
import SocialConnect from '@tcp/core/src/components/common/organisms/ProductImages/views/SocialConnect.view';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getBrandInCaps } from '@tcp/core/src/utils';
import { SHARE_ICON_STROKE } from '@tcp/core/src/constants/brandSpecific.constants';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import ShareStyle from '../Share.style';

class Share extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSocialIcons: false,
    };
    this.toggleSocial = this.toggleSocial.bind(this);
    this.ShareIcon = this.ShareIcon.bind(this);
  }

  ShareIcon = () => {
    const shareIconStroke = SHARE_ICON_STROKE[getBrandInCaps()];
    return (
      <span // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
          <svg width="33" height="35" viewBox="0 0 33 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.4707 12.6286H2.60582C2.29477 12.6286 1.57935 12.7986 1.2061 13.4789C0.832837 14.1591 1.05057 26.5166 1.2061 32.6103C1.36161 33.0354 1.85928 33.8857 2.60582 33.8857C3.35235 33.8857 21.5798 33.8857 30.6003 33.8857C31.0669 33.744 32 33.2905 32 32.6103C32 31.9301 32 19.5726 32 13.4789C32 13.1954 31.7201 12.6286 30.6003 12.6286C29.4805 12.6286 24.5348 12.6286 22.2019 12.6286" stroke="${shareIconStroke}" stroke-width="1.5"/>
          <path d="M16.5 2V24.1429" stroke="${shareIconStroke}" stroke-width="1.5"/>
          <path d="M10.7429 8.2L16.5 2L22.7 8.2" stroke="${shareIconStroke}" stroke-width="1.5"/>
          </svg>
          `,
        }}
      />
    );
  };

  toggleSocial() {
    requestAnimationFrame(() => {
      this.setState((prevState) => ({
        showSocialIcons: !prevState.showSocialIcons,
      }));
    });
  }

  render() {
    const { showSocialIcons } = this.state;
    const {
      className,
      isFacebookEnabled,
      isPinterestEnabled,
      isTwitterEnabled,
      ratingsProductId,
      isMiniPDP,
    } = this.props;
    const share = (
      <div
        className={`${className} share-icon-wrapper-new-pdp ${showSocialIcons ? 'expanded' : ''} ${
          isMiniPDP ? 'miniPDP' : ''
        }`}
      >
        <button
          onClick={this.toggleSocial}
          className="share-icon-new-pdp clear-button"
          aria-label="toggle social sharing options"
        >
          {this.ShareIcon()}
        </button>
      </div>
    );
    const social = (
      <SocialConnect
        className="social-icons-new-pdp"
        isFacebookEnabled={isFacebookEnabled}
        isPinterestEnabled={isPinterestEnabled}
        isTwitterEnabled={isTwitterEnabled}
        ratingsProductId={ratingsProductId}
        newShareIcon
        isNewPDPEnabled
      />
    );
    const socialShare = (
      <div className={`${className} social-share-new-pdp`}>
        {share}
        {social}
      </div>
    );

    return showSocialIcons ? socialShare : share;
  }
}

Share.defaultProps = {
  className: '',
  isTwitterEnabled: true,
  isFacebookEnabled: true,
  isPinterestEnabled: true,
};

Share.propTypes = {
  className: PropTypes.string,
  isTwitterEnabled: PropTypes.bool,
  isFacebookEnabled: PropTypes.bool,
  isPinterestEnabled: PropTypes.bool,
  ratingsProductId: PropTypes.string.isRequired,
};

export default withStyles(errorBoundary(Share), ShareStyle);
export { Share as ShareVanilla };
